// extracted by mini-css-extract-plugin
module.exports = {"EledoPdfEditor":"EledoPdfEditor_EledoPdfEditor__2qkrk","teField":"EledoPdfEditor_teField__3SV4J"};